/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { FB_APP_ID } from '/client/src/constants';
const queryString = require('query-string');

type PropsType = {
  page: string,
  eventDetail: {
    id: string | number,
    url_name: string
  },
  reasonOptions?: any
};

const Frame = ({ page, reasonOptions, eventDetail }: PropsType): React.Element<'iframe'> => {
  const _context = React.useContext(DefaultContainerContext);

  if (!page) {
    return null;
  }

  const subDir = process.env.NODE_ENV === 'development' ? 'dev' : 'prod';

  let pageURL = '';

  if (page === 'splash') {
    const query = {
      from: 'embed',
      skip: 1,
      preview: true
    };

    if (reasonOptions && reasonOptions.code) {
      query.code = reasonOptions.code;
    }

    const param = queryString.stringify(query);

    const url = `${process.env.EVENT_HOST}${eventDetail.url_name}?${param}`;

    // eslint-disable-next-line
    pageURL = `/pages/preview/${subDir}/${page}.html?url=${encodeURIComponent(url)}&previewUrl=${process.env.EVENT_HOST}${eventDetail.url_name}`;
  } else if (page === 'calendar' || page === 'cards') {
    const theme = _.get(_context, 'profileCurrent.calendar_theme', 'Classic');

    // eslint-disable-next-line
    pageURL = `/pages/preview/${subDir}/${page}.html?merchant_id=${_context.profileCurrent.id}&previewUrl=${_context.profileCurrent.website}&theme=${theme}`;
  } else {
    const query = {
      event_id: eventDetail.id,
      ticket_id: _.get(eventDetail, 'tickets[0].id', '0'),
      page_url: `${process.env.EVENT_HOST}facebook/${_.get(reasonOptions, 'page_id', _.get(eventDetail, 'facebook_page.id', 0))}?from=facebook`,
      previewUrl: page === 'facebook' ?
        `www.facebook.com/${_.get(reasonOptions, 'page_id', _.get(eventDetail, 'facebook_page.id', '0'))}/app/${FB_APP_ID}` :
        _.get(_context, 'profileCurrent.website', 'www.yourwebsite.com')
    };

    if (reasonOptions && reasonOptions.code) {
      query.code = reasonOptions.code;
    }

    const param = queryString.stringify(query);

    pageURL = `/pages/preview/${subDir}/${page}.html?${param}`;
  }

  return (
    <iframe
      style={{
        width: '100%',
        height: '100%'
      }}
      className='sp-client-iframe'
      src={pageURL}
    />
  );
};

export default Frame;
